const collapsibles = document.querySelectorAll(".collapsible");
collapsibles.forEach((item)=>item.addEventListener("click", function() {
        this.classList.toggle("collapsible--expanded");
    }));

//# sourceMappingURL=index.544849a7.js.map
